import mock from '../MockConfig';
import tenantList from '../../db/tenantList';

mock.onGet('/api/tenant/list').reply(200, tenantList);
